import { PropsWithChildren, ReactElement, useEffect, useState } from "react"

import { checkKemsuWebSystemSessionValidity, getUserInfo, logout, userSessionStore } from "~/domain/user-session"
import { createHOC } from "~/shared/lib/hocs"
import { Loading } from "~/shared/ui"


/*import mainGlobalCss from "~/shared/assets/main.global.scss?inline"

function VPNMessage(props: { curIp: string }) {

	const [inProcess, setInProcess] = useState(false)

	const reload = () => {
		setInProcess(true)
		location.reload()
	}

	const logout = () => {
		setInProcess(true)
		void userSessionStore.logout()
	}

	return <div style={{
		width: "100vw",
		height: "100vh",
		display: "flex",
		alignItems: "start",
		justifyContent: "center",
		marginTop: "12rem"
	}}>
		<GlobalStyle>{mainGlobalCss}</GlobalStyle>
		<div style={{ maxWidth: "90%", display: "flex", gap: "0.5rem", flexDirection: "column" }}>
			<Message type="error" style={{ display: "inline-flex", flexDirection: "column", gap: "0.25rem" }}>
				<p>IP адрес, с которого был осуществлен вход, изменился.</p>
				<p>Возможно, включен VPN или VPN был включен при входе в систему.</p>
				<p>Отключите VPN и нажмите кнопку Обновить или выйдите и зайдите в систему заново.</p>
			</Message>
			<Message type="info">
				<p>
					<span>IP с которого выполнен вход: {" "}</span>
					<i>{userSessionStore.authIp}</i>
				</p>
				<p>
					<span>Текущий IP: {" "}</span>
					<i>{props.curIp}</i>
				</p>
			</Message>
			<div style={{ display: "flex", alignItems: "center", gap: "0.5rem", justifyContent: "end" }}>
				{inProcess && <Loading loading title="" delay={0} />}
				<Button disabled={inProcess} onClick={reload} colorStyle="primary">Обновить</Button>
				<Button disabled={inProcess} onClick={logout} colorStyle="secondary">Выйти</Button>
			</div>
		</div>
	</div>
}
*/

/**
 * Компонент, который выполнит начальные проверки и инициализацию, перед тем как начать рендер приложения.
 * @param props
 * @component
 * @category Component
 */
export function Bootstrap({
							  children
						  }: PropsWithChildren): ReactElement | null {

	const [isValidated, setIsValidated] = useState(false)
	//const [curIp, setCurIp] = useState("")

	useEffect(() => {

		(async () => {

			const userInfo = getUserInfo()

			/*if (userInfo) {
				const curIp = await userSessionStore.getCurrentIp()
				setCurIp(curIp)

				if (curIp && userSessionStore.authIp && curIp !== userSessionStore.authIp) {
					return
				}
			}*/

			const canRefreshToken = await userSessionStore.canRefreshToken()

			if (
				(userInfo && !canRefreshToken) ||
				(!userInfo && canRefreshToken)
			) {
				await logout()
				return
			} else if (userInfo && canRefreshToken) {


				const isValidKemsuWebSystemSession = await checkKemsuWebSystemSessionValidity();

				if(!isValidKemsuWebSystemSession) {
					await logout();
					return;
				}

				userSessionStore.updateActivityDate()

				await userSessionStore.initialRefreshTokenJob()

				if (document.visibilityState !== "hidden") {
					userSessionStore.scheduleRefreshTokenJob()
				}
			}

			setIsValidated(true)
		})()

		return () => {
			userSessionStore.stopRefreshTokenJob()
		}

	}, [])

	// Обновление страницы, взятой из кэша.
	/*useEffect(() => {
		const handler = (event: PageTransitionEvent) => {
			if (event.persisted) {
				console.log("Страница взята из кэша. Обновим...")
				window.location.reload()
			}
		}

		window.addEventListener("pageshow", handler)

		return () => window.removeEventListener("pageshow", handler)
	}, [])*/

	/*if (curIp && userSessionStore.authIp && curIp !== userSessionStore.authIp) {
		return <VPNMessage curIp={curIp} />
	}*/

	return isValidated ? (
		<>{children}</>
	) : (
		<div data-testid="bootstrap-loading" className="w-[100vw] h-[100vh] flex items-center justify-center">
			<Loading loading delay={0.5} />
		</div>
	)
}

export const withBootstrap = createHOC((element) => (
	<Bootstrap>{element}</Bootstrap>
), "WithBootstrap")
